<div class="fit-80">
  <app-header></app-header>
  <div class="border-top-none">
    <app-selected-client></app-selected-client>
  </div>
  <div>
    <!-- <form> -->
    <!-- <ng-template matStepLabel>Declaration 1</ng-template> -->

    <div class="border-top-none">
      <div class="fit-80 card-container mb-5 grey-banner">{{'FORM3_OD0125' | translate}}</div>

      <div class="fit-80 card-container grey-banner h-44">
        <div class="d-flex justify-center">
          <p>{{'FORM3_OD0126' | translate}}</p>
          <a class="ml-3 tool-tip" data-toggle="tooltip" data-placement="bottom"
            title="{{'FORM3_OD0127' | translate}} ">
            <img style="width: 25px;" src="../../../../../assets/Logos/info.svg" alt="More Information">
          </a>
        </div>
      </div>
    </div>

    <div class="blue-background d-flex border-top-none">
      <div class="w-65 pl6">{{'FORM3_OD0128' | translate}}</div>
      <div class="w-35">{{'FORM3_OD0129' | translate}} ({{'FORM3_DATEFORMAT_OD0129' | translate}})</div>
    </div>
    <div>

      <div class="d-flex border-top-none overflow-auto" style="max-height: 300px;">
        <div class="w-100">
          <table class="table table-striped table-bordered">
            <tbody>
              <tr *ngFor="let field of fieldArray; let i = index; count as c" class="d-flex">
                <div class="w-65 apply-border-right">
                  <td>
                    {{i+1}}<span>.</span>
                  </td>
                  <td>
                    <input [(ngModel)]="field.Nom" class="form-control" placeholder="{{'FORM3_OD0208' | translate}}"
                      type="text" name="{{field.Nom}}" (keydown)="onKeydown($event)"
                      [ngModelOptions]="{standalone: true}" />
                  </td>
                  <td>
                    <input [(ngModel)]="field.Prenom" class="form-control" placeholder="{{'FORM3_OD0209' | translate}}"
                      type="text" name="{{field.Prenom}}" (keydown)="onKeydown($event)"
                      [ngModelOptions]="{standalone: true}" />
                  </td>
                </div>
                <div class="w-35">
                  <td>
                    <input class="px-1 date-picker" name="{{field.DateNaiss}}"  [min]="minDate" [max]="maxDate"
                      [matDatepicker]="picker" placeholder="__/__/____" [(ngModel)]="field.DateNaiss" (keyup)="dataEntered()" (dateChange)="addEventFBox('change', $event,i)"/>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <!-- <input [(ngModel)]="field.DateNaiss" class="form-control date-banner" type="date" name="{{field.DateNaiss}}"
                      [ngModelOptions]="{standalone: true}" /> -->
                  </td>
                  <td>
                    <button aria-label="delete row" class="btn btn-default" type="button"
                      (click)="deleteFirstboxFieldValue(i)">
                      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="26" height="26"
                        viewBox="0 0 172 172" style=" fill:#000000;">
                        <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                          stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                          font-family="none" font-weight="none" font-size="none" text-anchor="none"
                          style="mix-blend-mode: normal">
                          <path d="M0,172v-172h172v172z" fill="#e74c3c"></path>
                          <g fill="#000000">
                            <path
                              d="M69.46154,1.03365c-19.94952,0 -35.97115,13.69592 -35.97115,39.89904c0,17.10697 6.82212,34.54988 17.15865,45.27404c4.03125,10.72416 -3.23017,14.72957 -4.75481,15.29808c-20.87981,7.64904 -45.27404,21.55169 -45.27404,35.35096v5.16827c0,18.8125 35.81611,23.15385 69.04808,23.15385c7.28726,0 14.60036,-0.3101 21.70673,-0.82692c-8.73437,-9.2512 -14.05769,-21.62921 -14.05769,-35.35096c0,-11.83533 4.03125,-22.71454 10.75,-31.42308c-1.00781,-2.32572 -1.39543,-5.99519 0.41346,-11.57692c10.28486,-10.75 16.95192,-28.03786 16.95192,-45.06731c0,-26.20312 -16.02163,-39.89904 -35.97115,-39.89904zM129,87.24038c-23.05048,0 -41.75962,18.68329 -41.75962,41.75962c0,23.07632 18.68329,41.75962 41.75962,41.75962c23.07632,0 41.75962,-18.68329 41.75962,-41.75962c0,-23.07632 -18.70913,-41.75962 -41.75962,-41.75962zM105.84615,123.00481h46.10096v11.99038h-46.10096z">
                            </path>
                          </g>
                        </g>
                      </svg>
                    </button>
                  </td>
                </div>
              </tr>
              <tr class="d-flex">
                <div class="w-65 apply-border-right">
                  <td style="padding-right: 3rem;">
                    <!-- {{countRows+1}}<span>.</span> -->
                  </td>
                  <td>
                    <input class="form-control" type="text" id="newAttributeFirstName"
                      placeholder="{{'FORM3_OD0208' | translate}}" [maxlength]="25" (keyup)="dataEntered()"
                      [(ngModel)]="newAttribute.Nom" (keydown)="onKeydown($event)" name="newAttributeFirstName"
                      required />
                  </td>
                  <td>
                    <input class="form-control" type="text" id="newAttributeLastName"
                      placeholder="{{'FORM3_OD0209' | translate}}" [maxlength]="25" (keyup)="dataEntered()"
                      [(ngModel)]="newAttribute.Prenom" (keydown)="onKeydown($event)" name="newAttributeLastName"
                      required />
                  </td>
                </div>
                <div class="w-35">
                  <td>
                    <input class="px-1 date-picker" name='newAttribute.DateNaiss' [min]="minDate" [max]="maxDate"
                      max="9999-12-31" [matDatepicker]="picker" placeholder="{{'FORM3_DATEFORMAT_OD0129' | translate}}"
                      [(ngModel)]="newAttribute.DateNaiss" (keyup)="dataEntered()"/>
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                    <!-- <input class="form-control date-banner" type="date" id="newAttributeDate" max="9999-12-31" (keyup)="dataEntered()"
                      [(ngModel)]="newAttribute.DateNaiss" name="newAttributeDate" required /> -->
                  </td>
                  <td>
                    <button aria-label="add row" class="btn btn-default" type="button" (click)="addFieldValueFBox()">
                      <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="26" height="26"
                        viewBox="0 0 172 172" style=" fill:#000000;">
                        <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                          stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                          font-family="none" font-weight="none" font-size="none" text-anchor="none"
                          style="mix-blend-mode: normal">
                          <path d="M0,172v-172h172v172z" fill="#3498db"></path>
                          <g fill="#000000">
                            <path
                              d="M69.46154,1.03365c-19.94952,0 -35.97115,13.69592 -35.97115,39.89904c0,17.10697 6.82212,34.54988 17.15865,45.27404c4.03125,10.72416 -3.23017,14.72957 -4.75481,15.29808c-20.87981,7.64904 -45.27404,21.55169 -45.27404,35.35096v5.16827c0,18.8125 35.81611,23.15385 69.04808,23.15385c7.28726,0 14.60036,-0.3101 21.70673,-0.82692c-8.73437,-9.2512 -14.05769,-21.62921 -14.05769,-35.35096c0,-11.83533 4.03125,-22.71454 10.75,-31.42308c-1.00781,-2.32572 -1.39543,-5.99519 0.41346,-11.57692c10.28486,-10.75 16.95192,-28.03786 16.95192,-45.06731c0,-26.20312 -16.02163,-39.89904 -35.97115,-39.89904zM129,87.24038c-23.05048,0 -41.75962,18.68329 -41.75962,41.75962c0,23.07632 18.68329,41.75962 41.75962,41.75962c23.07632,0 41.75962,-18.68329 41.75962,-41.75962c0,-23.07632 -18.70913,-41.75962 -41.75962,-41.75962zM123.21154,105.84615h11.57692v17.15865h17.15865v11.99038h-17.15865v17.15865h-11.57692v-17.15865h-17.36538v-11.99038h17.36538z">
                            </path>
                          </g>
                        </g>
                      </svg>
                    </button>
                  </td>
                </div>
              </tr>
            </tbody>
          </table>
      
        </div>
      </div>
    </div>
    <div *ngIf="errorEmptyFields1 || errorThreshold1" class="p-1 border-top-none text-center">
      <p *ngIf="errorEmptyFields1" class="error-message">{{'FORM3_error_names_OD0199'|translate}}</p>
      <p *ngIf="errorThreshold1" class="error-message">{{'FORM3_error_Threshold_OD0195'|translate}}</p>
    </div>
    <div class="border-top-none pt-5">
      <div class="fit-80 d-flex grey-banner card-container h-44 justify-center">
        <p>{{'FORM3_OD0131' | translate}}</p>
        <a class="ml-3 tool-tip" data-toggle="tooltip" data-placement="bottom" title="{{'FORM3_OD0132' | translate}} ">
          <img style="width: 25px;" src="../../../../../assets/Logos/info.svg" alt="More Information">
        </a>
      </div>
    </div>

    <div class="blue-background d-flex border-top-none">
      <div class="w-65 pl6">{{'FORM3_OD0128' | translate}}</div>
      <div class="w-35">{{'FORM3_OD0129' | translate}} ({{'FORM3_DATEFORMAT_OD0129' | translate}})</div>
    </div>

    <div class="d-flex border-top-none overflow-auto" style="max-height: 300px;">

      <div class="w-100">
        <table class="table table-striped table-bordered">

          <tbody>
            <tr *ngFor="let field of fieldArraySBox; let i = index" class="d-flex">

              <div class="w-65 apply-border-right">
                <td>
                  {{i+1}}<span>.</span>
                </td>
                <td>
                  <input [(ngModel)]="field.Nom" class="form-control" placeholder="{{'FORM3_OD0208' | translate}}"
                    type="text" [maxlength]="25" (keydown)="onKeydown($event)" name="{{field.Nom}}"
                    [ngModelOptions]="{standalone: true}" />
                </td>
                <td disabled>
                  <input [(ngModel)]="field.Prenom" class="form-control" placeholder="{{'FORM3_OD0209' | translate}}"
                    type="text" [maxlength]="25" (keydown)="onKeydown($event)" name="{{field.Prenom}}"
                    [ngModelOptions]="{standalone: true}" />
                </td>
              </div>
              <div class="w-35">
                <td>
                  <input class="px-1 date-picker" name='{{field.DateNaiss}}' [min]="minDate" [max]="maxDate"
                    [matDatepicker]="picker" [(ngModel)]="field.DateNaiss"
                     (dateChange)="addEventSBox('change', $event,i)"  placeholder="{{'FORM3_DATEFORMAT_OD0129' | translate}}"/>
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                  <!-- <input [(ngModel)]="field.DateNaiss" class="form-control date-banner" type="date" [maxlength]="5" name="{{field.DateNaiss}}"
                    [ngModelOptions]="{standalone: true}" /> -->
                </td>
                <td>
                  <button aria-label="delete row" class="btn btn-default" type="button"
                    (click)="deleteSecondBoxFieldValue(i)">
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="26" height="26" viewBox="0 0 172 172"
                      style=" fill:#000000;">
                      <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                        stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                        font-family="none" font-weight="none" font-size="none" text-anchor="none"
                        style="mix-blend-mode: normal">
                        <path d="M0,172v-172h172v172z" fill="#e74c3c"></path>
                        <g fill="#000000">
                          <path
                            d="M69.46154,1.03365c-19.94952,0 -35.97115,13.69592 -35.97115,39.89904c0,17.10697 6.82212,34.54988 17.15865,45.27404c4.03125,10.72416 -3.23017,14.72957 -4.75481,15.29808c-20.87981,7.64904 -45.27404,21.55169 -45.27404,35.35096v5.16827c0,18.8125 35.81611,23.15385 69.04808,23.15385c7.28726,0 14.60036,-0.3101 21.70673,-0.82692c-8.73437,-9.2512 -14.05769,-21.62921 -14.05769,-35.35096c0,-11.83533 4.03125,-22.71454 10.75,-31.42308c-1.00781,-2.32572 -1.39543,-5.99519 0.41346,-11.57692c10.28486,-10.75 16.95192,-28.03786 16.95192,-45.06731c0,-26.20312 -16.02163,-39.89904 -35.97115,-39.89904zM129,87.24038c-23.05048,0 -41.75962,18.68329 -41.75962,41.75962c0,23.07632 18.68329,41.75962 41.75962,41.75962c23.07632,0 41.75962,-18.68329 41.75962,-41.75962c0,-23.07632 -18.70913,-41.75962 -41.75962,-41.75962zM105.84615,123.00481h46.10096v11.99038h-46.10096z">
                          </path>
                        </g>
                      </g>
                    </svg>
                  </button>
                </td>
              </div>
            </tr>
            <tr class="d-flex">
              <div class="w-65 apply-border-right">
                <td style="padding-right: 3rem;">
                  <!-- {{countRowsSBox+1}}<span>.</span> -->
                </td>
                <td>
                  <input class="form-control" type="text" id="newAttributeSBoxFirstName"
                    placeholder="{{'FORM3_OD0208' | translate}}" (keyup)="dataEntered()" [maxlength]="25"
                    [(ngModel)]="newAttributeSBox.Nom" (keydown)="onKeydown($event)" name="newAttributeSBoxFirstName" />
                </td>
                <td>
                  <input class="form-control" type="text" id="newAttributeSBoxLastName"
                    placeholder="{{'FORM3_OD0209' | translate}}" (keyup)="dataEntered()" [maxlength]="25"
                    [(ngModel)]="newAttributeSBox.Prenom" (keydown)="onKeydown($event)"
                    name="newAttributeSBoxLastName" />
                </td>
              </div>
              <div class="w-35">
                <td>
                  <input class="px-1 date-picker" name='newAttributeSBox.DateNaiss' [min]="minDate" [max]="maxDate"
                    [matDatepicker]="picker1" placeholder="{{'FORM3_DATEFORMAT_OD0129' | translate}}" [(ngModel)]="newAttributeSBox.DateNaiss" />
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                  <!-- (dateChange)="addEvent('change', $event)" -->

                  <!-- <input class="form-control date-banner" type="date" id="newAttributeSBoxDate" max="9999-12-31"
                    [(ngModel)]="newAttributeSBox.DateNaiss" name="newAttributeSBoxDate" /> -->
                </td>
                <td>
                  <button aria-label="add row" class="btn btn-default" type="button" (click)="addFieldValueSBox()">
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="26" height="26" viewBox="0 0 172 172"
                      style=" fill:#000000;">
                      <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                        stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                        font-family="none" font-weight="none" font-size="none" text-anchor="none"
                        style="mix-blend-mode: normal">
                        <path d="M0,172v-172h172v172z" fill="#3498db"></path>
                        <g fill="#000000">
                          <path
                            d="M69.46154,1.03365c-19.94952,0 -35.97115,13.69592 -35.97115,39.89904c0,17.10697 6.82212,34.54988 17.15865,45.27404c4.03125,10.72416 -3.23017,14.72957 -4.75481,15.29808c-20.87981,7.64904 -45.27404,21.55169 -45.27404,35.35096v5.16827c0,18.8125 35.81611,23.15385 69.04808,23.15385c7.28726,0 14.60036,-0.3101 21.70673,-0.82692c-8.73437,-9.2512 -14.05769,-21.62921 -14.05769,-35.35096c0,-11.83533 4.03125,-22.71454 10.75,-31.42308c-1.00781,-2.32572 -1.39543,-5.99519 0.41346,-11.57692c10.28486,-10.75 16.95192,-28.03786 16.95192,-45.06731c0,-26.20312 -16.02163,-39.89904 -35.97115,-39.89904zM129,87.24038c-23.05048,0 -41.75962,18.68329 -41.75962,41.75962c0,23.07632 18.68329,41.75962 41.75962,41.75962c23.07632,0 41.75962,-18.68329 41.75962,-41.75962c0,-23.07632 -18.70913,-41.75962 -41.75962,-41.75962zM123.21154,105.84615h11.57692v17.15865h17.15865v11.99038h-17.15865v17.15865h-11.57692v-17.15865h-17.36538v-11.99038h17.36538z">
                          </path>
                        </g>
                      </g>
                    </svg>
                  </button>
                </td>
              </div>
            </tr>
          </tbody>
        </table>
        
      </div>

    </div>
    <div *ngIf="errorEmptyFields2 || errorThreshold2" class="p-1 border-top-none text-center">
      <p *ngIf="errorEmptyFields2" class="error-message">{{'FORM3_error_names_OD0199'|translate}}</p>
      <p *ngIf="errorThreshold2" class="error-message">{{'FORM3_error_Threshold_OD0195'|translate}}</p>
    </div>
    <div class="border-top-none  overflow-auto">
      <div class="blue-background  remark">{{'Declaration_affaires_OD0104' | translate}}</div>
      <div class="text-center " style="background-color: gainsboro;">
        <textarea class="w-88 my-4" [maxlength]="400" (keyup)="dataEntered()" [(ngModel)]="remarks" placeholder=""
          name="remarks">
          </textarea>
      </div>
      <div class="p-1 text-center">
        <!-- <p *ngIf="errorEmptyFields2" class="error-message">{{'FORM3_error_names_OD0199'|translate}}</p>
          <p *ngIf="errorThreshold2" class="error-message">{{'FORM3_error_Threshold_OD0195'|translate}}</p> -->
        <p *ngIf="msgErrorNotSaved" class="error-message">Error -Data Not saved</p>
        <p *ngIf="errorClickAddButton" class="error-message">{{'FORM3_error_names_OD0200'|translate}}</p>
        <p *ngIf="independantUsersEmptyError" class="error-message">{{'FORMS3_IndependentUser_0D0200' | translate}} </p>
        <!-- <p *ngIf="independantUsersEmptyError" class="error-message">Please add atleast one Independant User </p> -->
      </div>

      <div class="align-buttons  py-5 px-4">
        <div>
          <app-popup [isDataEntered]=isDataEntered></app-popup>
        </div>

        <div>
          <button class="btn-orange p-2" (click)="ValidateAndSaveForm3()" [disabled]="clicked">
            <svg class="mr-3" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="32" height="32"
              viewBox="0 0 172 172" style=" fill:#000000;">
              <g fill="none" fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt"
                stroke-linejoin="miter" stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0"
                font-family="none" font-weight="none" font-size="none" text-anchor="none"
                style="mix-blend-mode: normal">
                <path d="M0,172v-172h172v172z" fill="#e67e22"></path>
                <g fill="#ffffff">
                  <path
                    d="M51.87435,21.42301c-0.26282,0.00646 -0.5248,0.03219 -0.78385,0.07699h-9.88216c-10.82086,0 -19.70833,8.88748 -19.70833,19.70833v89.58333c0,10.82086 8.88748,19.70833 19.70833,19.70833h6.28483c0.57703,0.09479 1.16565,0.09479 1.74268,0h73.50732c0.57703,0.09479 1.16565,0.09479 1.74268,0h6.30583c10.82086,0 19.70833,-8.88748 19.70833,-19.70833v-75.25c-0.0005,-1.53552 -0.65764,-2.99752 -1.80566,-4.01725l-32.25,-28.66667c-0.9835,-0.87419 -2.25348,-1.35728 -3.56934,-1.35775h-2.7015c-0.57703,-0.09479 -1.16565,-0.09479 -1.74268,0h-55.59066c-0.31897,-0.05468 -0.64222,-0.08045 -0.96582,-0.07699zM41.20833,32.25h5.375v19.70833c0,6.86192 5.67974,12.54167 12.54167,12.54167h43c6.86192,0 12.54167,-5.67974 12.54167,-12.54167v-16.29997l25.08333,22.29785v72.83545c0,5.01031 -3.94802,8.95833 -8.95833,8.95833h-1.79167v-41.20833c0,-6.86192 -5.67974,-12.54167 -12.54167,-12.54167h-60.91667c-6.86192,0 -12.54167,5.67974 -12.54167,12.54167v41.20833h-1.79167c-5.01031,0 -8.95833,-3.94802 -8.95833,-8.95833v-89.58333c0,-5.01031 3.94802,-8.95833 8.95833,-8.95833zM57.33333,32.25h46.58333v19.70833c0,1.05724 -0.73442,1.79167 -1.79167,1.79167h-43c-1.05724,0 -1.79167,-0.73442 -1.79167,-1.79167zM55.54167,96.75h60.91667c1.05724,0 1.79167,0.73442 1.79167,1.79167v41.20833h-64.5v-41.20833c0,-1.05724 0.73442,-1.79167 1.79167,-1.79167z">
                  </path>
                </g>
              </g>
            </svg>
            {{'Declaration_affaires_OD0105' | translate}} </button>
        </div>
      </div>
    </div>
    <!-- </form> -->
  </div>
</div>


<ng-http-loader [entryComponent]="customSpinnerComponent"></ng-http-loader>